// extracted by mini-css-extract-plugin
export var buttonContainer = "pricingV3-module--buttonContainer--59da1";
export var centeredPlans = "pricingV3-module--centeredPlans--34035";
export var collapsible = "pricingV3-module--collapsible--b396f";
export var collapsibleContainer = "pricingV3-module--collapsibleContainer--162a1";
export var contactsSlider = "pricingV3-module--contactsSlider--54979";
export var creditsSlider = "pricingV3-module--creditsSlider--0d717";
export var desktopPlans = "pricingV3-module--desktopPlans--c119c";
export var disclaimer = "pricingV3-module--disclaimer--8119b";
export var iconDown = "pricingV3-module--iconDown--015ee";
export var iconUp = "pricingV3-module--iconUp--7ad82";
export var introPricing = "pricingV3-module--introPricing--594b7";
export var messagesSlider = "pricingV3-module--messagesSlider--4aea9";
export var mobileDisclaimer = "pricingV3-module--mobileDisclaimer--d926d";
export var mobilePlans = "pricingV3-module--mobilePlans--3822d";
export var plans = "pricingV3-module--plans--9cb8b";
export var platformCards = "pricingV3-module--platformCards--978cb";
export var platformCardsTitle = "pricingV3-module--platformCardsTitle--385b4";
export var pricingV3 = "pricingV3-module--pricingV3--9e64f";
export var servicePlans = "pricingV3-module--servicePlans--a7d8e";
export var serviceSubHeadline = "pricingV3-module--serviceSubHeadline--3747d";
export var styledPlanCard = "pricingV3-module--styledPlanCard--5096b";